import React from 'react';
import { DataList } from 'commons-ui';
import { useStyletron } from 'baseui';
import useKeys from './useKeys';
import columnConfigs from './keysConfig';
import useZookeeperActions from '../../utils/useZookeeperActions';
import { makeActionHandler } from '../../actions/handler';
import { makeKeysActionList } from '../../actions/list';

const Keys: React.FC<{}> = () => {
	const { getServiceKeys, serviceName } = useKeys();
	const { getActionHandler, getActionList } = useZookeeperActions(makeActionHandler, makeKeysActionList);
	const actions = getActionList();

	const [css] = useStyletron();

	return (
		<div
			className={css({
				padding: '20px'
			})}>
			<div
				className={css({
					fontSize: '32',
					fontWeight: 'bold'
				})}>
				{`List of Keys:  ${serviceName}`}
			</div>
			<DataList
				fetchData={getServiceKeys}
				columnConfigs={columnConfigs}
				actions={actions}
				getActionHandler={getActionHandler}
				rowHeight={100}
				entity='Service keys'
				initialSortDirection='ASC'
				initialSortIndex={1}
			/>
		</div>
	);
};

export default Keys;
